var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBannerLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 204,
    viewBox: "0 0 312 204",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-8.7%",
    y: "-13.2%",
    width: "117.3%",
    height: "126.5%",
    filterUnits: "objectBoundingBox",
    id: "banner-light_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-10.3%",
    y: "-66.7%",
    width: "120.5%",
    height: "252.4%",
    filterUnits: "objectBoundingBox",
    id: "banner-light_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".488%",
    x2: "50%",
    y2: "100%",
    id: "banner-light_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAEFFE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAEFFE",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "banner-light_svg__b",
    x: 0,
    y: 0,
    width: 312,
    height: 204,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h312v38a4 4 0 01-4 4H4a4 4 0 01-4-4V0z",
    id: "banner-light_svg__e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#banner-light_svg__a)",
    xlinkHref: "#banner-light_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    fill: "#FFF",
    xlinkHref: "#banner-light_svg__b"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAEFFE",
    width: 312,
    height: 204,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0h304a4 4 0 014 4v8H0V4a4 4 0 014-4z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFE5EB",
    d: "M.5 11.5h311v1H.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B6C1CD",
    x: 4,
    y: 4,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B6C1CD",
    x: 11,
    y: 4,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B6C1CD",
    x: 18,
    y: 4,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1E4FE",
    d: "M16 105h58v58H16zM90 131h58v32H90zM90 35h58v80H90zM164 105h58v58h-58zM238 124h58v39h-58zM238 35h58v73h-58zM164 35h58v54h-58zM16 35h58v54H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#banner-light_svg__c)",
    d: "M10 35h292v128H10z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 162)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#banner-light_svg__d)",
    xlinkHref: "#banner-light_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#banner-light_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M241 174h40v18h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#FFF",
    d: "M247 181h28v4h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.502 183.444l-2.169-2.168a.667.667 0 01.943-.943l2.168 2.169 2.169-2.169a.667.667 0 01.943.943l-2.169 2.168 2.169 2.169a.667.667 0 01-.943.943l-2.169-2.169-2.168 2.169a.667.667 0 01-.943-.943l2.169-2.169z",
    fill: "#162D3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fill: "#7A92A5",
    d: "M12 174h114v6H12zM12 186h76v6H12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fill: "#7A92A5",
    d: "M201 181h28v4h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M195.5 174.5h39v17h-39z"
  })))));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='312px' height='204px' viewBox='0 0 312 204' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3EPreview Banner / Light%3C/title%3E %3Cdefs%3E %3Crect id='path-1' x='0' y='0' width='312' height='204' rx='4'%3E%3C/rect%3E %3Cfilter x='-8.7%25' y='-13.2%25' width='117.3%25' height='126.5%25' filterUnits='objectBoundingBox' id='filter-2'%3E %3CfeOffset dx='0' dy='6' in='SourceAlpha' result='shadowOffsetOuter1'%3E%3C/feOffset%3E %3CfeGaussianBlur stdDeviation='3' in='shadowOffsetOuter1' result='shadowBlurOuter1'%3E%3C/feGaussianBlur%3E %3CfeComposite in='shadowBlurOuter1' in2='SourceAlpha' operator='out' result='shadowBlurOuter1'%3E%3C/feComposite%3E %3CfeColorMatrix values='0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.06 0' type='matrix' in='shadowBlurOuter1' result='shadowMatrixOuter1'%3E%3C/feColorMatrix%3E %3CfeOffset dx='0' dy='0' in='SourceAlpha' result='shadowOffsetOuter2'%3E%3C/feOffset%3E %3CfeGaussianBlur stdDeviation='9' in='shadowOffsetOuter2' result='shadowBlurOuter2'%3E%3C/feGaussianBlur%3E %3CfeComposite in='shadowBlurOuter2' in2='SourceAlpha' operator='out' result='shadowBlurOuter2'%3E%3C/feComposite%3E %3CfeColorMatrix values='0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0' type='matrix' in='shadowBlurOuter2' result='shadowMatrixOuter2'%3E%3C/feColorMatrix%3E %3CfeMerge%3E %3CfeMergeNode in='shadowMatrixOuter1'%3E%3C/feMergeNode%3E %3CfeMergeNode in='shadowMatrixOuter2'%3E%3C/feMergeNode%3E %3C/feMerge%3E %3C/filter%3E %3ClinearGradient x1='50%25' y1='0.48828125%25' x2='50%25' y2='100%25' id='linearGradient-3'%3E %3Cstop stop-color='%23DAEFFE' offset='0%25'%3E%3C/stop%3E %3Cstop stop-color='%23DAEFFE' stop-opacity='0' offset='100%25'%3E%3C/stop%3E %3C/linearGradient%3E %3Cpath d='M0,0 L312,0 L312,38 C312,40.209139 310.209139,42 308,42 L4,42 C1.790861,42 2.705415e-16,40.209139 0,38 L0,0 L0,0 Z' id='path-4'%3E%3C/path%3E %3Cfilter x='-10.3%25' y='-66.7%25' width='120.5%25' height='252.4%25' filterUnits='objectBoundingBox' id='filter-5'%3E %3CfeOffset dx='0' dy='4' in='SourceAlpha' result='shadowOffsetOuter1'%3E%3C/feOffset%3E %3CfeGaussianBlur stdDeviation='10' in='shadowOffsetOuter1' result='shadowBlurOuter1'%3E%3C/feGaussianBlur%3E %3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0' type='matrix' in='shadowBlurOuter1'%3E%3C/feColorMatrix%3E %3C/filter%3E %3C/defs%3E %3Cg id='Preview-Banner-/-Light' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Group-11'%3E %3Cg id='Rectangle'%3E %3Cuse fill='black' fill-opacity='1' filter='url(%23filter-2)' xlink:href='%23path-1'%3E%3C/use%3E %3Cuse fill-opacity='0' fill='%23FFFFFF' fill-rule='evenodd' xlink:href='%23path-1'%3E%3C/use%3E %3C/g%3E %3Crect id='Rectangle' fill='%23DAEFFE' x='0' y='0' width='312' height='204' rx='4'%3E%3C/rect%3E %3Cg id='B-Bar'%3E %3Cpath d='M4,0 L308,0 C310.209139,-3.17995656e-14 312,1.790861 312,4 L312,12 L312,12 L0,12 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z' id='Rectangle' fill='%23FFFFFF'%3E%3C/path%3E %3Crect id='Rectangle' stroke='%23DFE5EB' x='0.5' y='11.5' width='311' height='1'%3E%3C/rect%3E %3Crect id='Rectangle' fill='%23B6C1CD' x='4' y='4' width='4' height='4' rx='2'%3E%3C/rect%3E %3Crect id='Rectangle' fill='%23B6C1CD' x='11' y='4' width='4' height='4' rx='2'%3E%3C/rect%3E %3Crect id='Rectangle' fill='%23B6C1CD' x='18' y='4' width='4' height='4' rx='2'%3E%3C/rect%3E %3C/g%3E %3Crect id='Rectangle' fill='%23C1E4FE' x='16' y='105' width='58' height='58'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-6' fill='%23C1E4FE' x='90' y='131' width='58' height='32'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-14' fill='%23C1E4FE' x='90' y='35' width='58' height='80'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-9' fill='%23C1E4FE' x='164' y='105' width='58' height='58'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-11' fill='%23C1E4FE' x='238' y='124' width='58' height='39'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-15' fill='%23C1E4FE' x='238' y='35' width='58' height='73'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-19' fill='%23C1E4FE' x='164' y='35' width='58' height='54'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-20' fill='%23C1E4FE' x='16' y='35' width='58' height='54'%3E%3C/rect%3E %3Crect id='Rectangle' fill='url(%23linearGradient-3)' x='10' y='35' width='292' height='128'%3E%3C/rect%3E %3C/g%3E %3Cg id='Group-38' transform='translate(0.000000, 162.000000)'%3E %3Cg id='Rectangle-Copy-16'%3E %3Cuse fill='black' fill-opacity='1' filter='url(%23filter-5)' xlink:href='%23path-4'%3E%3C/use%3E %3Cuse fill='%23FFFFFF' fill-rule='evenodd' xlink:href='%23path-4'%3E%3C/use%3E %3C/g%3E %3Cg id='Group-17' transform='translate(241.000000, 12.000000)'%3E %3Crect id='Rectangle-Copy-17' fill='%23000000' x='0' y='0' width='40' height='18'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-4' fill-opacity='0.3' fill='%23FFFFFF' x='6' y='7' width='28' height='4'%3E%3C/rect%3E %3C/g%3E %3Cg id='01-Foundation-/-Icon-Small-18-/-01-Actions-/-08-Dismiss' transform='translate(287.000000, 13.000000)' fill='%23162D3D'%3E %3Cpath d='M7.5016354,8.44444444 L5.33333333,6.27614237 C5.07298381,6.01579285 5.07298381,5.59368286 5.33333333,5.33333333 C5.59368286,5.07298381 6.01579285,5.07298381 6.27614237,5.33333333 L8.44444444,7.5016354 L10.6127465,5.33333333 C10.873096,5.07298381 11.295206,5.07298381 11.5555556,5.33333333 C11.8159051,5.59368286 11.8159051,6.01579285 11.5555556,6.27614237 L9.38725349,8.44444444 L11.5555556,10.6127465 C11.8159051,10.873096 11.8159051,11.295206 11.5555556,11.5555556 C11.295206,11.8159051 10.873096,11.8159051 10.6127465,11.5555556 L8.44444444,9.38725349 L6.27614237,11.5555556 C6.01579285,11.8159051 5.59368286,11.8159051 5.33333333,11.5555556 C5.07298381,11.295206 5.07298381,10.873096 5.33333333,10.6127465 L7.5016354,8.44444444 Z' id='Color'%3E%3C/path%3E %3C/g%3E %3Crect id='Rectangle' fill-opacity='0.2' fill='%237A92A5' x='12' y='12' width='114' height='6'%3E%3C/rect%3E %3Crect id='Rectangle-Copy' fill-opacity='0.2' fill='%237A92A5' x='12' y='24' width='76' height='6'%3E%3C/rect%3E %3C/g%3E %3Cg id='Group-36' transform='translate(195.000000, 174.000000)'%3E %3Crect id='Rectangle-Copy-4' fill-opacity='0.2' fill='%237A92A5' x='6' y='7' width='28' height='4'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-18' stroke='%23000000' x='0.5' y='0.5' width='39' height='17'%3E%3C/rect%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgBannerLight as ReactComponent };